import { z } from 'zod';
import { ModalidadSchema } from './common.js';
import { EstadoAsignacionSchema, EstadoSimulacionSchema } from './estados.js';

// ---------- GET /api/mis-asignaciones (§3.1, TUTOR/ADMINISTRADOR) ----------

export const AsignacionLabEscenarioSchema = z.object({
  id: z.string(),
  nombre: z.string(),
  /** Laxo + narrowing con `isModalidadConocida` (ver `common.ts`). */
  modalidad: ModalidadSchema,
  duracionMaxMin: z.number(),
});
export type AsignacionLabEscenario = z.infer<typeof AsignacionLabEscenarioSchema>;

export const AsignacionLabSimulacionActivaSchema = z.object({
  id: z.string(),
  estado: EstadoSimulacionSchema,
});
export type AsignacionLabSimulacionActiva = z.infer<typeof AsignacionLabSimulacionActivaSchema>;

export const AsignacionLabSchema = z.object({
  id: z.string(),
  estado: EstadoAsignacionSchema,
  /** ISO datetime. */
  disponibleHasta: z.string(),
  escenario: AsignacionLabEscenarioSchema,
  simulacion_activa: AsignacionLabSimulacionActivaSchema.nullable(),
});
export type AsignacionLab = z.infer<typeof AsignacionLabSchema>;

export const MisAsignacionesResponseSchema = z.array(AsignacionLabSchema);
export type MisAsignacionesResponse = z.infer<typeof MisAsignacionesResponseSchema>;

// ---------- POST /api/asignacion/resetear (§3.2) ----------

export const ResetearAsignacionRequestSchema = z.object({
  asignacionId: z.string(),
});
export type ResetearAsignacionRequest = z.infer<typeof ResetearAsignacionRequestSchema>;

// ---------- GET /api/simulacion/prompt?simulacionId=... (§3.3) ----------

/**
 * Prompt del SP. INV-05: nunca exponer al ALUMNO. Endpoint sólo accesible
 * por TUTOR y ADMINISTRADOR (el backend valida el rol; el cliente tampoco
 * debe llamarlo desde contextos de alumno).
 */
export const PromptSimulacionResponseSchema = z.object({
  prompt: z.string(),
  version: z.string(),
});
export type PromptSimulacionResponse = z.infer<typeof PromptSimulacionResponseSchema>;
